import type { ReactElement } from "react";
import { Route } from "react-router";
import { MODULE_MANIFESTS } from "@/app/router/module-manifests";
import { ProtectedRoute } from "@/app/router/protected-route";
import { resolveIconName } from "@/shared/components/icons/icon-map";
import { ModuleComingSoonCard } from "@/shared/components/module-placeholder/module-coming-soon-card";

const MODULE_PLACEHOLDER_IDS = new Set(["member", "industry-resource-directory", "jobs"]);

const placeholderManifests = MODULE_MANIFESTS.filter((manifest) =>
  MODULE_PLACEHOLDER_IDS.has(manifest.moduleId),
);

function createModulePlaceholderRoute(manifest: (typeof MODULE_MANIFESTS)[number]): ReactElement {
  return (
    <Route
      key={manifest.moduleId}
      path={`${manifest.routeBase.slice(1)}/*`}
      element={
        <ProtectedRoute
          requiredRoles={manifest.requiredRoles}
          roleMatch={"roleMatch" in manifest ? manifest.roleMatch : undefined}
        >
          <div className="mx-auto max-w-4xl">
            <ModuleComingSoonCard
              moduleId={manifest.moduleId}
              displayName={manifest.displayName}
              icon={resolveIconName(manifest.navIcon)}
            />
          </div>
        </ProtectedRoute>
      }
    />
  );
}

export const ModulePlaceholderRoutes = placeholderManifests.map(createModulePlaceholderRoute);

/**
 * Admin module placeholder routes are rendered only on the admin realm host;
 * the standard realm host never serves `/admin` content.
 */
export const AdminModulePlaceholderRoutes = MODULE_MANIFESTS.filter(
  (manifest) => manifest.moduleId === "admin",
).map(createModulePlaceholderRoute);
